import React, { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import MainSidebar from "../Mainsidebar";
import visaImage from "../../Images/visa.png";
import mastercardImage from "../../Images/mastercard.png";
import paypalImage from "../../Images/paypal2.png";
import americanexpressImage from "../../Images/american-express.png";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import "../../Style/CreateInvoice.css";
import "../../Style/Print.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toWords } from "number-to-words";
import { path_url } from "../../Config/config";
import axios from "axios";
import ESign from "../../Utils/ESign";

const DEFAULT_PRODUCT_OPTIONS = [
  { value: "sample-1", label: "Raw Materials A", hsnCode: "2801", uom: "KG", rate: 500, discount: 0, cgst: 9, sgst: 9, igst: 0 },
  { value: "sample-2", label: "Packaging Boxes", hsnCode: "4819", uom: "PCS", rate: 45, discount: 5, cgst: 6, sgst: 6, igst: 0 },
  { value: "sample-3", label: "Electronic Components", hsnCode: "8542", uom: "PCS", rate: 1200, discount: 0, cgst: 9, sgst: 9, igst: 0 },
  { value: "sample-4", label: "Industrial Machinery Parts", hsnCode: "8487", uom: "SET", rate: 15000, discount: 10, cgst: 9, sgst: 9, igst: 0 },
  { value: "sample-5", label: "Office Supplies / Stationery", hsnCode: "4802", uom: "BRL", rate: 300, discount: 5, cgst: 6, sgst: 6, igst: 0 },
];

const customDropdownStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  menu: (base) => ({
    ...base,
    zIndex: 99999,
    minWidth: "220px",
    borderRadius: "8px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
    border: "1px solid #e2e5ec",
    padding: "4px",
  }),
  control: (base, state) => ({
    ...base,
    minHeight: "36px",
    height: "36px",
    borderRadius: "6px",
    borderColor: state.isFocused ? "#7b55ff" : "#e2e5ec",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(123, 85, 255, 0.15)" : "none",
    "&:hover": { borderColor: "#7b55ff" },
    fontSize: "0.85rem",
    backgroundColor: "#fff",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#7b55ff"
      : state.isFocused
        ? "#f3f0ff"
        : "#fff",
    color: state.isSelected ? "#fff" : "#2b2d3a",
    fontSize: "0.85rem",
    borderRadius: "4px",
    cursor: "pointer",
    padding: "6px 10px",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
};

const CreatePurchaseOrder = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };

  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };

  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);

  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };

  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  // Table Column Names (same standard structure as Invoice)
  const columnNames = [
    "S. No.",
    "Product Description",
    "HSN code",
    "UOM",
    "Qty",
    "Rate",
    "Amount",
    "Discount",
    "Taxable Value",
    "CGST Rate",
    "CGST Amount",
    "SGST Rate",
    "SGST Amount",
    "IGST Rate",
    "IGST Amount",
    "Total",
  ];

  const [rows, setRows] = useState([]);
  const [totalSubtotal, setTotalSubtotal] = useState(0);
  const [totalGrandtotal, setTotalGrandtotal] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [tax, setTax] = useState({
    cgstTax: 0,
    sgstTax: 0,
    igstTax: 0,
  });
  const [amountInWords, setAmountInWords] = useState("");
  const [packingCharges, setPackingCharges] = useState(0);
  const [freight, setFreight] = useState(0);
  const [insurance, setInsurance] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [vendorId, setVendorId] = useState(null);

  // Buyer (Our Company)
  const [senderData, setSenderData] = useState({
    name: "",
    address: "",
    gstin: "",
    state: "",
    code: "",
  });

  // Supplier / Vendor
  const [receiverData, setReceiverData] = useState({
    name: "",
    address: "",
    gstin: "",
    state: "",
    code: "",
  });

  useEffect(() => {
    if (location.state?.vendor) {
      const v = location.state.vendor;
      const vendorName =
        v.companyname ||
        v.vendorName ||
        v.companyName ||
        v.name ||
        `${v.firstname || v.fname || ""} ${v.lastname || v.lname || ""}`.trim();
      const vendorAddress =
        v.address ||
        v.add1 ||
        `${v.street || ""} ${v.city || ""} ${v.state || ""} ${v.pincode || v.pinCode || ""}`.trim();
      setReceiverData({
        name: vendorName,
        address: vendorAddress,
        gstin: v.gstNo || v.gstin || v.gst_no || "",
        state: v.state || "",
        code: v.pincode || v.pinCode || "",
      });
      setVendorId(location.state.vendorId || v.id || v.vendorid || null);
    }
  }, [location.state]);

  const [poDetails, setPoDetails] = useState({
    poNo: "",
    poDate: new Date(),
    dueDate: null,
    reverseCharge: { value: "No", label: "No" },
    state: "",
    code: "",
  });

  const [transportData, setTransportData] = useState({
    transportMode: "",
    vehicleNumber: "",
    date: null,
    place: "",
  });

  const [bankDetails, setBankDetails] = useState({
    bankName: "",
    bankAccNo: "",
    bankIFSC: "",
    termsAndConditions: "",
  });

  const [poType, setPoType] = useState({
    value: "original",
    label: "Original",
  });

  const poTypeOptions = [
    { value: "original", label: "Original" },
    { value: "duplicate", label: "Duplicate" },
    { value: "triplicate", label: "Triplicate" },
    { value: "extraOC", label: "Extra OC" },
  ];

  // ESign Modal state
  const [lgShow, setLgShow] = useState(false);
  const sigCanvasRef = useRef(null);

  const handleESignModal = () => setLgShow(true);
  const handleCloseModal = () => setLgShow(false);

  const handleSenderDataChange = (e) => {
    const { name, value } = e.target;
    setSenderData((prev) => ({ ...prev, [name]: value }));
  };

  const handleReceiverDataChange = (e) => {
    const { name, value } = e.target;
    setReceiverData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePoDetailsChange = (name, value) => {
    setPoDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleTransportDataChange = (name, value) => {
    setTransportData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePackingChargesChange = (e) => {
    const val = e.target.value;
    setPackingCharges(val);
    recalculateTotals(rows, freight, insurance, val);
  };

  const handleFreightChange = (e) => {
    const val = e.target.value;
    setFreight(val);
    recalculateTotals(rows, val, insurance, packingCharges);
  };

  const handleInsuranceChange = (e) => {
    const val = e.target.value;
    setInsurance(val);
    recalculateTotals(rows, freight, val, packingCharges);
  };

  const handleBankDetailsChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prev) => ({ ...prev, [name]: value }));
  };

  // Row calculation helper
  const calculateRow = (row) => {
    const qty = parseFloat(row["Qty"]) || 0;
    const rate = parseFloat(row["Rate"]) || 0;
    const amount = Number((qty * rate).toFixed(2));
    const discount = parseFloat(row["Discount"]) || 0;
    const taxableValue = Number(Math.max(0, amount - (amount * discount) / 100).toFixed(2));
    const cgstRate = parseFloat(row["CGST Rate"]) || 0;
    const sgstRate = parseFloat(row["SGST Rate"]) || 0;
    const igstRate = parseFloat(row["IGST Rate"]) || 0;

    const cgstAmount = Number(((taxableValue * cgstRate) / 100).toFixed(2));
    const sgstAmount = Number(((taxableValue * sgstRate) / 100).toFixed(2));
    const igstAmount = Number(((taxableValue * igstRate) / 100).toFixed(2));
    const total = Number((taxableValue + cgstAmount + sgstAmount + igstAmount).toFixed(2));

    return {
      ...row,
      Amount: amount,
      "Taxable Value": taxableValue,
      "CGST Amount": cgstAmount,
      "SGST Amount": sgstAmount,
      "IGST Amount": igstAmount,
      Total: total,
    };
  };

  // Recalculate purchase order totals
  const recalculateTotals = (
    currentRows,
    fVal = freight,
    iVal = insurance,
    pVal = packingCharges
  ) => {
    let subtotal = 0;
    let cgstSum = 0;
    let sgstSum = 0;
    let igstSum = 0;

    currentRows.forEach((r) => {
      subtotal += parseFloat(r["Taxable Value"]) || 0;
      cgstSum += parseFloat(r["CGST Amount"]) || 0;
      sgstSum += parseFloat(r["SGST Amount"]) || 0;
      igstSum += parseFloat(r["IGST Amount"]) || 0;
    });

    const totalTaxVal = Number((cgstSum + sgstSum + igstSum).toFixed(2));
    const extraCharges = (parseFloat(fVal) || 0) + (parseFloat(iVal) || 0) + (parseFloat(pVal) || 0);
    const grand = Number((subtotal + totalTaxVal + extraCharges).toFixed(2));

    setTotalSubtotal(Number(subtotal.toFixed(2)));
    setTax({
      cgstTax: Number(cgstSum.toFixed(2)),
      sgstTax: Number(sgstSum.toFixed(2)),
      igstTax: Number(igstSum.toFixed(2)),
    });
    setTotalTax(totalTaxVal);
    setTotalGrandtotal(grand);

    try {
      const roundedInt = Math.round(grand);
      if (roundedInt > 0) {
        setAmountInWords(
          toWords(roundedInt).replace(/^\w/, (c) => c.toUpperCase()) + " Rupees Only"
        );
      } else {
        setAmountInWords("");
      }
    } catch {
      setAmountInWords("");
    }
  };

  const handleInputChange = (index, field, value) => {
    setRows((prevRows) => {
      const newRows = [...prevRows];
      newRows[index] = { ...newRows[index], [field]: value };
      const updatedRow = calculateRow(newRows[index]);
      newRows[index] = updatedRow;
      recalculateTotals(newRows);
      return newRows;
    });
  };

  const handleProductSelect = (index, selectedOption) => {
    setRows((prevRows) => {
      const newRows = [...prevRows];
      if (selectedOption) {
        newRows[index] = {
          ...newRows[index],
          "Product Description": selectedOption,
          "HSN code": selectedOption.hsnCode || newRows[index]["HSN code"] || "",
          UOM: selectedOption.uom || newRows[index].UOM || "PCS",
          Rate: selectedOption.rate !== undefined ? selectedOption.rate : newRows[index].Rate,
          Discount: selectedOption.discount !== undefined ? selectedOption.discount : newRows[index].Discount,
          "CGST Rate": selectedOption.cgst !== undefined ? selectedOption.cgst : newRows[index]["CGST Rate"],
          "SGST Rate": selectedOption.sgst !== undefined ? selectedOption.sgst : newRows[index]["SGST Rate"],
          "IGST Rate": selectedOption.igst !== undefined ? selectedOption.igst : newRows[index]["IGST Rate"],
        };
      } else {
        newRows[index] = {
          ...newRows[index],
          "Product Description": null,
        };
      }
      const updatedRow = calculateRow(newRows[index]);
      newRows[index] = updatedRow;
      recalculateTotals(newRows);
      return newRows;
    });
  };

  const addRow = () => {
    setRows((prevRows) => {
      const newRow = {
        "S. No.": prevRows.length + 1,
        "Product Description": null,
        "HSN code": "",
        UOM: "PCS",
        Qty: 1,
        Rate: 0,
        Amount: 0,
        Discount: 0,
        "Taxable Value": 0,
        "CGST Rate": 9,
        "CGST Amount": 0,
        "SGST Rate": 9,
        "SGST Amount": 0,
        "IGST Rate": 0,
        "IGST Amount": 0,
        Total: 0,
      };
      const calculated = calculateRow(newRow);
      const nextRows = [...prevRows, calculated];
      recalculateTotals(nextRows);
      return nextRows;
    });
  };

  const handleDeleteRow = (index) => {
    setRows((prevRows) => {
      if (prevRows.length <= 1) {
        toast.info("At least one product item is required in the purchase order.");
        return prevRows;
      }
      const filtered = prevRows.filter((_, i) => i !== index);
      const nextRows = filtered.map((r, i) => ({ ...r, "S. No.": i + 1 }));
      recalculateTotals(nextRows);
      return nextRows;
    });
    toast.success("Product removed");
  };

  const handleCalculation = () => {
    setRows((prevRows) => {
      const updatedRows = prevRows.map((r) => calculateRow(r));
      recalculateTotals(updatedRows);
      return updatedRows;
    });
    toast.success("Taxes and purchase order totals calculated successfully!");
  };

  // Helper to ensure vendor with address is created if needed
  const createVendorWithAddress = async (token, usercid, adminId) => {
    try {
      const vendorName = receiverData.name || "Purchase Order Vendor";
      const nameParts = vendorName.trim().split(" ");
      const firstName = nameParts[0] || "Vendor";
      const lastName = nameParts.slice(1).join(" ") || "Supplier";

      const vendorPayload = {
        firstname: firstName,
        lastname: lastName,
        companyname: vendorName,
        mobile: "9876543210",
        email: `${firstName.toLowerCase().replace(/[^a-z0-9]/g, "")}_${Date.now()}@supplier.com`,
        gstnumber: receiverData.gstin || "",
        address1: receiverData.address || "Industrial Area, Indore",
        address2: "",
        city: (receiverData.address || "Indore").split(",")[0].trim() || "Indore",
        state: receiverData.state || "Madhya Pradesh",
        country: "India",
        pincode: parseInt(receiverData.code) || 452010,
        status: "OPEN",
        leadsource: "Indiamart",
        usercid: usercid || adminId,
        useradminid: adminId,
        owner: adminId,
      };

      console.log("Creating vendor with payload:", vendorPayload);
      const vRes = await axios.post(`${path_url}/vendor`, vendorPayload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const createdVId =
        vRes.data?.body?.id ||
        vRes.data?.body?.vendor?.id ||
        vRes.data?.id ||
        vRes.data?.vendor?.id;

      if (createdVId) {
        console.log("Created vendor ID:", createdVId);

        // Create Vendor Billing Address (single instance)
        const billingPayload = {
          vendorid: createdVId,
          active: true,
          name: receiverData.name || "Vendor Billing Address",
          Address1: receiverData.address || "Industrial Area, Indore",
          address1: receiverData.address || "Industrial Area, Indore",
          Address2: "",
          address2: "",
          City: (receiverData.address || "Indore").split(",")[0].trim() || "Indore",
          city: (receiverData.address || "Indore").split(",")[0].trim() || "Indore",
          State: receiverData.state || "Madhya Pradesh",
          state: receiverData.state || "Madhya Pradesh",
          Pincode: parseInt(receiverData.code) || 452010,
          pincode: parseInt(receiverData.code) || 452010,
          Country: "India",
          country: "India",
          useradminid: adminId,
          usercid: usercid,
        };
        await axios.post(`${path_url}/vendor/billingaddress`, billingPayload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }).catch((e) => console.warn("Vendor billing address creation info:", e?.response?.status));

        // Create Vendor Shipping Address (single instance)
        const shippingPayload = {
          vendorid: createdVId,
          active: true,
          name: senderData.name || "Buyer Shipping Address",
          Address1: senderData.address || "Vijay Nagar, Indore",
          address1: senderData.address || "Vijay Nagar, Indore",
          Address2: "",
          address2: "",
          City: (senderData.address || "Indore").split(",")[0].trim() || "Indore",
          city: (senderData.address || "Indore").split(",")[0].trim() || "Indore",
          State: senderData.state || "Madhya Pradesh",
          state: senderData.state || "Madhya Pradesh",
          Pincode: parseInt(senderData.code) || 452010,
          pincode: parseInt(senderData.code) || 452010,
          Country: "India",
          country: "India",
          useradminid: adminId,
          usercid: usercid,
        };
        await axios.post(`${path_url}/vendor/shippingaddress`, shippingPayload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }).catch((e) => console.warn("Vendor shipping address creation info:", e?.response?.status));

        return createdVId;
      }
      return null;
    } catch (err) {
      console.error("Error creating vendor with address:", err);
      return null;
    }
  };

  const formatDateForBackend = (dateVal) => {
    if (!dateVal) return new Date().toISOString().split("T")[0];
    if (dateVal instanceof Date) {
      const year = dateVal.getFullYear();
      const month = String(dateVal.getMonth() + 1).padStart(2, "0");
      const day = String(dateVal.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    if (typeof dateVal === "string") {
      return dateVal.split("T")[0];
    }
    return new Date().toISOString().split("T")[0];
  };

  // Save Purchase Order to Backend
  const handleSavePurchaseOrder = async () => {
    const token = localStorage.getItem("accessToken");
    const usercid =
      localStorage.getItem("userId") ||
      localStorage.getItem("adminId") ||
      localStorage.getItem("usercid");
    const adminId = localStorage.getItem("adminId");

    if (!token) {
      toast.error("You are not logged in. Please login first.");
      return;
    }

    setIsSaving(true);
    try {
      let targetVendorId = vendorId;

      // If no vendorId, check if receiverData matches any existing vendor in vendorList
      if (!targetVendorId && vendorList && vendorList.length > 0) {
        const matchingVendor = vendorList.find(
          (v) =>
            (receiverData.name && v.companyname && v.companyname.toLowerCase() === receiverData.name.toLowerCase()) ||
            (receiverData.name && v.firstname && `${v.firstname} ${v.lastname || ""}`.trim().toLowerCase() === receiverData.name.toLowerCase())
        );
        if (matchingVendor) {
          targetVendorId = matchingVendor.id;
          setVendorId(targetVendorId);
        }
      }

      if (!targetVendorId) {
        targetVendorId = await createVendorWithAddress(token, usercid, adminId);
        if (targetVendorId) {
          setVendorId(targetVendorId);
        } else if (vendorList && vendorList.length > 0) {
          targetVendorId = vendorList[0].id;
        }
      }

      if (!targetVendorId) {
        toast.error("Could not associate vendor for purchase order. Please enter supplier details.");
        return;
      }

      const formattedDueDate = formatDateForBackend(poDetails.dueDate);

      const payload = {
        status: "New",
        vendorid: targetVendorId,
        usercid: usercid,
        useradminid: adminId,
        subject: poDetails.poNo
          ? `Purchase Order - ${poDetails.poNo}`
          : "Purchase Order",
        PONumber: poDetails.poNo || `PO-${Date.now().toString().slice(-4)}`,
        duedate: formattedDueDate,
        priority: "Normal",
        groupCategory: "Purchase",
        totalPOamount: totalGrandtotal || 0,
        totalcgst: tax.cgstTax || 0,
        totalsgst: tax.sgstTax || 0,
        totaligst: tax.igstTax || 0,
        totalpaidamount: 0,
        dueAmount: totalGrandtotal || 0,
        amountinwords: amountInWords || "Zero",
        PONotes: bankDetails.termsAndConditions || "",
        taxType: "Master",
        editMode: true,
        editedBy: usercid,
        owner: usercid,
        asignedto: usercid,
      };

      console.group("🚀 [API CALL] Starting Purchase Order Save Process");
      console.log("PO Payload to be sent:", payload);

      try {
        console.log(`📡 [API CALL] POST ${path_url}/po`);
        const response = await axios.post(`${path_url}/po`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        console.log("✅ [API RESPONSE] Purchase Order saved successfully:", response.status, response.data);
        console.groupEnd();
        toast.success("Purchase Order saved successfully to database!");
      } catch (firstErr) {
        console.warn("⚠️ [API ERROR] First POST /po attempt failed:", firstErr?.response?.status, firstErr?.response?.data || firstErr.message);

        const errMsg = (
          firstErr?.response?.data?.message ||
          firstErr?.response?.data?.error ||
          (typeof firstErr?.response?.data === "string" ? firstErr.response.data : "") ||
          firstErr?.message ||
          ""
        ).toLowerCase();

        // If backend throws vendor address not found, automatically create vendor with full address and retry
        if (errMsg.includes("address") || errMsg.includes("vendor") || errMsg.includes("billing") || errMsg.includes("shipping")) {
          console.log("🔧 Vendor address issue encountered. Creating vendor with full address and retrying...");
          const newVendorId = await createVendorWithAddress(
            token,
            usercid,
            adminId
          );
          if (newVendorId) {
            payload.vendorid = newVendorId;
            setVendorId(newVendorId);
            console.log(`📡 [API CALL] Retrying POST ${path_url}/po with vendor ID: ${newVendorId}`);
            const retryRes = await axios.post(`${path_url}/po`, payload, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            });
            console.log("✅ [API RESPONSE] PO saved retry response:", retryRes.status, retryRes.data);
            console.groupEnd();
            toast.success("Purchase Order saved successfully to database!");
            return;
          }
        }
        console.groupEnd();
        throw firstErr;
      }
    } catch (error) {
      console.error("❌ [API ERROR] Error saving purchase order:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        (typeof error?.response?.data === "string" ? error.response.data : null) ||
        error?.message ||
        "Failed to save purchase order to backend. Please check your backend connection.";
      toast.error(errorMessage);
    } finally {
      setIsSaving(false);
    }
  };

  // Initial load default row & products
  useEffect(() => {
    if (rows.length === 0) {
      const initialRow = {
        "S. No.": 1,
        "Product Description": { value: "sample-1", label: "Raw Materials A", hsnCode: "2801", uom: "KG", rate: 500, discount: 0, cgst: 9, sgst: 9, igst: 0 },
        "HSN code": "2801",
        UOM: "KG",
        Qty: 10,
        Rate: 500,
        Amount: 5000,
        Discount: 0,
        "Taxable Value": 5000,
        "CGST Rate": 9,
        "CGST Amount": 450,
        "SGST Rate": 9,
        "SGST Amount": 450,
        "IGST Rate": 0,
        "IGST Amount": 0,
        Total: 5900,
      };
      const initialRows = [initialRow];
      setRows(initialRows);
      recalculateTotals(initialRows);
    }
  }, []);

  // Data fetching
  const [data, setData] = useState(null);
  const [vendorList, setVendorList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("accessToken");
      const adminId = localStorage.getItem("adminId");
      if (!token || !adminId) return;

      try {
        const productRes = await axios.get(`${path_url}/product/invoice/${adminId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        setData(productRes.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }

      try {
        const vendorRes = await axios.get(`${path_url}/vendor/dashboard/${adminId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        if (vendorRes.data?.body?.vendorList) {
          setVendorList(vendorRes.data.body.vendorList);
        }
      } catch (err) {
        console.error("Error fetching vendors:", err);
      }
    };
    fetchData();
  }, []);

  const dynamicProductOptions =
    data && data.length > 0
      ? data.map((item) => ({
        value: item.id || item.productname,
        label: item.productname,
        hsnCode: item.hsnCode || "",
        uom: item.uom || item.unit || "PCS",
        rate: item.salesPrice || item.rate || 0,
        discount: item.discount || 0,
        cgst: item.cgstRate || item.cgst || 9,
        sgst: item.sgstRate || item.sgst || 9,
        igst: item.igstRate || item.igst || 0,
      }))
      : DEFAULT_PRODUCT_OPTIONS;

  return (
    <>
      <div>
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            isRightMenu={isRightMenu}
            setisRightMenu={setisRightMenu}
            handelRightMenuShow={handelRightMenuShow}
            isSearchShow={isSearchShow}
            setIsSearchShow={setIsSearchShow}
            handelShow={handelShow}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
          />
          <ToastContainer />
          <div className="content-wrapper">
            <section className="content-header">
              <div className="container-fluid">
                <div className="row mb-2 align-items-center">
                  <div className="col-sm-6">
                    <h4>Create Purchase Order</h4>
                  </div>
                  <div className="col-sm-6">
                    <ul className="breadcrumb float-sm-right mb-2">
                      <li className="breadcrumb-item">
                        <Link to="/crm-dashboard">Home</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/vendor-dashboard">Vendors</Link>
                      </li>
                      <li className="breadcrumb-item">
                        Create Purchase Order
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="callout callout-info">
                      <h5>
                        <i className="fas fa-info" /> Note:
                      </h5>
                      Review vendor pricing, quantities, and terms before confirming the Purchase Order.
                    </div>
                    {/* Main content */}
                    <div className="invoice p-3 mb-3">
                      <div className="row">
                        <div className="col-12 company-details">
                          <h4>
                            <div>
                              <i className="fas fa-building" /> Indsac ERP
                            </div>
                            <small className="float-right">
                              Date:{" "}
                              <div style={{ width: "130px" }}>
                                <DatePicker
                                  className="border"
                                  style={{ width: "100%" }}
                                  selected={poDetails.poDate}
                                  onChange={(date) =>
                                    handlePoDetailsChange("poDate", date)
                                  }
                                  dateFormat="dd-MM-yyyy"
                                />
                              </div>
                              <div style={{ width: "130px", marginLeft: "10px" }}>
                                <Select
                                  value={poType}
                                  onChange={setPoType}
                                  options={poTypeOptions}
                                  styles={customDropdownStyles}
                                  menuPortalTarget={document.body}
                                  isSearchable={false}
                                />
                              </div>
                            </small>
                          </h4>
                        </div>
                      </div>

                      {/* 4 Info Cards: Buyer, Supplier, PO Details, Transport */}
                      <div className="row invoice-info">
                        {/* Buyer Details */}
                        <div className="col-sm-3 invoice-col">
                          <b>Buyer / Consignee</b>
                          <form className="form-container">
                            <label htmlFor="buyerName">Company Name:</label>
                            <input
                              type="text"
                              id="buyerName"
                              name="name"
                              placeholder="Enter buyer company"
                              value={senderData.name}
                              onChange={handleSenderDataChange}
                            />

                            <label htmlFor="buyerAddress">Address:</label>
                            <textarea
                              rows="3"
                              id="buyerAddress"
                              name="address"
                              placeholder="Enter buyer address"
                              value={senderData.address}
                              onChange={handleSenderDataChange}
                            ></textarea>

                            <label htmlFor="buyerGstin">GSTIN:</label>
                            <input
                              type="text"
                              id="buyerGstin"
                              name="gstin"
                              placeholder="Enter GSTIN number"
                              value={senderData.gstin}
                              onChange={handleSenderDataChange}
                            />

                            <div className="form-group">
                              <div className="form-section">
                                <label htmlFor="buyerState">State:</label>
                                <input
                                  type="text"
                                  id="buyerState"
                                  name="state"
                                  placeholder="Enter state"
                                  value={senderData.state}
                                  onChange={handleSenderDataChange}
                                />
                              </div>

                              <div className="form-section">
                                <label htmlFor="buyerCode">PIN Code:</label>
                                <input
                                  type="text"
                                  id="buyerCode"
                                  name="code"
                                  placeholder="PIN code"
                                  value={senderData.code}
                                  onChange={handleSenderDataChange}
                                />
                              </div>
                            </div>
                          </form>
                        </div>

                        {/* Supplier / Vendor Details */}
                        <div className="col-sm-3 invoice-col">
                          <b>Supplier / Vendor</b>
                          <form className="form-container">
                            <label htmlFor="supplierName">Vendor Name:</label>
                            <input
                              type="text"
                              id="supplierName"
                              name="name"
                              placeholder="Enter supplier / vendor name"
                              value={receiverData.name}
                              onChange={handleReceiverDataChange}
                            />

                            <label htmlFor="supplierAddress">Address:</label>
                            <textarea
                              rows="3"
                              id="supplierAddress"
                              name="address"
                              placeholder="Enter supplier address"
                              value={receiverData.address}
                              onChange={handleReceiverDataChange}
                            ></textarea>

                            <label htmlFor="supplierGstin">GSTIN:</label>
                            <input
                              type="text"
                              id="supplierGstin"
                              name="gstin"
                              placeholder="Enter GSTIN number"
                              value={receiverData.gstin}
                              onChange={handleReceiverDataChange}
                            />

                            <div className="form-group">
                              <div className="form-section">
                                <label htmlFor="supplierState">State:</label>
                                <input
                                  type="text"
                                  id="supplierState"
                                  name="state"
                                  placeholder="Enter state"
                                  value={receiverData.state}
                                  onChange={handleReceiverDataChange}
                                />
                              </div>

                              <div className="form-section">
                                <label htmlFor="supplierCode">PIN Code:</label>
                                <input
                                  type="text"
                                  id="supplierCode"
                                  name="code"
                                  placeholder="PIN code"
                                  value={receiverData.code}
                                  onChange={handleReceiverDataChange}
                                />
                              </div>
                            </div>
                          </form>
                        </div>

                        {/* PO Details */}
                        <div className="col-sm-3 invoice-col">
                          <b>Purchase Order Details</b>
                          <form className="form-container">
                            <label htmlFor="poNo">PO Number:</label>
                            <input
                              type="text"
                              id="poNo"
                              name="poNo"
                              placeholder="Enter PO number (e.g. PO-001)"
                              value={poDetails.poNo}
                              onChange={(e) =>
                                handlePoDetailsChange("poNo", e.target.value)
                              }
                            />

                            <label htmlFor="dueDate">Due Date:</label>
                            <div className="invoice-datepicker hide-border">
                              <DatePicker
                                id="dueDate"
                                name="dueDate"
                                selected={poDetails.dueDate}
                                onChange={(date) =>
                                  handlePoDetailsChange("dueDate", date)
                                }
                                dateFormat="dd/MM/yyyy"
                                className="custom-datepicker"
                                placeholderText="Select due date"
                              />
                            </div>

                            <label htmlFor="reverseCharge">Reverse Charge:</label>
                            <div style={{ marginBottom: "12px" }}>
                              <Select
                                id="reverseCharge"
                                value={poDetails.reverseCharge}
                                onChange={(selected) =>
                                  handlePoDetailsChange("reverseCharge", selected)
                                }
                                options={[
                                  { value: "No", label: "No" },
                                  { value: "Yes", label: "Yes" },
                                ]}
                                styles={customDropdownStyles}
                                menuPortalTarget={document.body}
                                isSearchable={false}
                              />
                            </div>

                            <div className="form-group">
                              <div className="form-section">
                                <label htmlFor="poState">State:</label>
                                <input
                                  type="text"
                                  id="poState"
                                  name="state"
                                  placeholder="State"
                                  value={poDetails.state}
                                  onChange={(e) =>
                                    handlePoDetailsChange("state", e.target.value)
                                  }
                                />
                              </div>

                              <div className="form-section">
                                <label htmlFor="poCode">Code:</label>
                                <input
                                  type="text"
                                  id="poCode"
                                  name="code"
                                  placeholder="Code"
                                  value={poDetails.code}
                                  onChange={(e) =>
                                    handlePoDetailsChange("code", e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </form>
                        </div>

                        {/* Transport Details */}
                        <div className="col-sm-3 invoice-col">
                          <b>Transport & Supply Details</b>
                          <form className="form-container">
                            <label htmlFor="transportMode">Transport Mode:</label>
                            <input
                              type="text"
                              id="transportMode"
                              name="transportMode"
                              placeholder="Road / Air / Rail"
                              value={transportData.transportMode}
                              onChange={(e) =>
                                handleTransportDataChange("transportMode", e.target.value)
                              }
                            />

                            <label htmlFor="vehicleNumber">Vehicle Number:</label>
                            <input
                              type="text"
                              id="vehicleNumber"
                              name="vehicleNumber"
                              placeholder="Enter vehicle number"
                              value={transportData.vehicleNumber}
                              onChange={(e) =>
                                handleTransportDataChange("vehicleNumber", e.target.value)
                              }
                            />

                            <label htmlFor="transportDate">Dispatch Date:</label>
                            <div className="invoice-datepicker hide-border">
                              <DatePicker
                                id="transportDate"
                                name="transportDate"
                                selected={transportData.date}
                                onChange={(date) =>
                                  handleTransportDataChange("date", date)
                                }
                                dateFormat="dd/MM/yyyy"
                                className="custom-datepicker"
                                placeholderText="Select dispatch date"
                              />
                            </div>

                            <label htmlFor="place">Place of Supply:</label>
                            <input
                              type="text"
                              id="place"
                              name="place"
                              placeholder="Enter place of supply"
                              value={transportData.place}
                              onChange={(e) =>
                                handleTransportDataChange("place", e.target.value)
                              }
                            />
                          </form>
                        </div>
                      </div>

                      {/* Product Table with proper columns and responsive styling */}
                      <div className="horizontal-fix">
                        <div>
                          <table>
                            <thead>
                              <tr className="table-row">
                                {columnNames.slice(0, 9).map((value) => (
                                  <th key={value} rowSpan={2}>
                                    {value}
                                  </th>
                                ))}
                                <th colSpan={2} style={{ textAlign: "center" }}>CGST</th>
                                <th colSpan={2} style={{ textAlign: "center" }}>SGST</th>
                                <th colSpan={2} style={{ textAlign: "center" }}>IGST</th>
                                {columnNames.slice(15).map((value) => (
                                  <th key={value} rowSpan={2}>
                                    {value}
                                  </th>
                                ))}
                                <th rowSpan={2}>Action</th>
                              </tr>
                              <tr className="table-row">
                                {columnNames.slice(9, 11).map((value) => (
                                  <th key={value}>{value}</th>
                                ))}
                                {columnNames.slice(11, 13).map((value) => (
                                  <th key={value}>{value}</th>
                                ))}
                                {columnNames.slice(13, 15).map((value) => (
                                  <th key={value}>{value}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {rows.map((row, index) => (
                                <tr className="table-row" key={index}>
                                  <td className="input-cell" style={{ width: "50px", textAlign: "center" }}>
                                    <input
                                      type="number"
                                      value={row["S. No."]}
                                      onChange={(e) =>
                                        handleInputChange(index, "S. No.", e.target.value)
                                      }
                                      style={{ width: "45px", textAlign: "center" }}
                                    />
                                  </td>
                                  <td className="input-cell" style={{ minWidth: "220px" }}>
                                    <CreatableSelect
                                      value={row["Product Description"]}
                                      onChange={(value) =>
                                        handleProductSelect(index, value)
                                      }
                                      options={dynamicProductOptions}
                                      placeholder="Select / Type Product"
                                      isSearchable
                                      isClearable
                                      formatCreateLabel={(inputValue) => `Use "${inputValue}"`}
                                      styles={customDropdownStyles}
                                      menuPortalTarget={document.body}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="text"
                                      value={row["HSN code"] || ""}
                                      onChange={(e) =>
                                        handleInputChange(index, "HSN code", e.target.value)
                                      }
                                      style={{ width: "80px" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="text"
                                      value={row.UOM || "PCS"}
                                      onChange={(e) =>
                                        handleInputChange(index, "UOM", e.target.value)
                                      }
                                      style={{ width: "60px" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="number"
                                      min="1"
                                      value={row.Qty}
                                      onChange={(e) =>
                                        handleInputChange(index, "Qty", e.target.value)
                                      }
                                      style={{ width: "65px" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="number"
                                      step="any"
                                      min="0"
                                      value={row.Rate}
                                      onChange={(e) =>
                                        handleInputChange(index, "Rate", e.target.value)
                                      }
                                      style={{ width: "80px" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="text"
                                      value={`Rs. ${row.Amount ?? 0}`}
                                      readOnly
                                      style={{ width: "85px", background: "#f8f9fa", fontWeight: "500" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="number"
                                      step="any"
                                      min="0"
                                      max="100"
                                      value={row.Discount ?? 0}
                                      onChange={(e) =>
                                        handleInputChange(index, "Discount", e.target.value)
                                      }
                                      style={{ width: "55px" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="number"
                                      step="any"
                                      value={row["Taxable Value"] ?? 0}
                                      readOnly
                                      style={{ width: "85px", background: "#f8f9fa", fontWeight: "500" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="number"
                                      step="any"
                                      value={row["CGST Rate"] ?? 0}
                                      onChange={(e) =>
                                        handleInputChange(index, "CGST Rate", e.target.value)
                                      }
                                      style={{ width: "55px" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="number"
                                      step="any"
                                      value={row["CGST Amount"] ?? 0}
                                      readOnly
                                      style={{ width: "75px", background: "#f8f9fa" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="number"
                                      step="any"
                                      value={row["SGST Rate"] ?? 0}
                                      onChange={(e) =>
                                        handleInputChange(index, "SGST Rate", e.target.value)
                                      }
                                      style={{ width: "55px" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="number"
                                      step="any"
                                      value={row["SGST Amount"] ?? 0}
                                      readOnly
                                      style={{ width: "75px", background: "#f8f9fa" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="number"
                                      step="any"
                                      value={row["IGST Rate"] ?? 0}
                                      onChange={(e) =>
                                        handleInputChange(index, "IGST Rate", e.target.value)
                                      }
                                      style={{ width: "55px" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="number"
                                      step="any"
                                      value={row["IGST Amount"] ?? 0}
                                      readOnly
                                      style={{ width: "75px", background: "#f8f9fa" }}
                                    />
                                  </td>
                                  <td className="input-cell">
                                    <input
                                      type="text"
                                      value={`Rs. ${row.Total ?? 0}`}
                                      readOnly
                                      style={{ width: "90px", fontWeight: "700", color: "var(--inv-primary)", background: "#f8f9fa" }}
                                    />
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <button
                                      type="button"
                                      className="delete-button"
                                      onClick={() => handleDeleteRow(index)}
                                      title="Remove item"
                                    >
                                      <i className="fa fa-trash" aria-hidden="true" />
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div style={{ padding: "12px 14px", display: "flex", gap: "10px", background: "#fafbff", borderTop: "1px solid var(--inv-border)" }}>
                            <button className="addButton" onClick={addRow}>
                              <i className="fas fa-plus mr-1" /> Add Product
                            </button>
                            <button
                              className="addButton"
                              onClick={handleCalculation}
                              style={{ backgroundColor: "#5046e5" }}
                            >
                              <i className="fas fa-calculator mr-1" /> Calculate Tax
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Payment Terms & Summary Section */}
                      <div className="row payment-details">
                        <div className="col-lg-6">
                          {/* Amount in words */}
                          <div className="to-words">
                            <h3>Total Purchase Order Amount in Words</h3>
                            <p>Rs. {amountInWords || "ZERO RUPEES ONLY"}</p>
                          </div>

                          {/* Bank Details Form */}
                          <div className="bank-details-form">
                            <h2>Banking & Payment Terms</h2>
                            <div className="floating-label-group">
                              <input
                                type="text"
                                id="bankName"
                                name="bankName"
                                value={bankDetails.bankName}
                                onChange={handleBankDetailsChange}
                                className="form-control"
                                placeholder=" "
                                required
                              />
                              <label className="floating-label">Bank Name</label>
                            </div>
                            <div className="floating-label-group">
                              <input
                                type="text"
                                id="bankAccNo"
                                name="bankAccNo"
                                value={bankDetails.bankAccNo}
                                onChange={handleBankDetailsChange}
                                className="form-control"
                                placeholder=" "
                                required
                              />
                              <label className="floating-label">Bank Account Number</label>
                            </div>
                            <div className="floating-label-group">
                              <input
                                type="text"
                                id="bankIFSC"
                                name="bankIFSC"
                                value={bankDetails.bankIFSC}
                                onChange={handleBankDetailsChange}
                                className="form-control"
                                placeholder=" "
                                required
                              />
                              <label className="floating-label">Bank IFSC Code</label>
                            </div>
                            <div className="floating-label-group">
                              <textarea
                                id="termsAndConditions"
                                name="termsAndConditions"
                                value={bankDetails.termsAndConditions}
                                onChange={handleBankDetailsChange}
                                className="form-control"
                                placeholder=" "
                                rows="3"
                                required
                              />
                              <label className="floating-label">Terms and Conditions</label>
                            </div>
                          </div>

                          {/* Accepted Payment Modes */}
                          <p className="lead mb-2">
                            Accepted Payment Modes:
                            <img src={visaImage} alt="Visa" />
                            <img src={mastercardImage} alt="Mastercard" />
                            <img src={americanexpressImage} alt="American Express" />
                            <img src={paypalImage} alt="Paypal" />
                          </p>
                        </div>

                        {/* Summary Table */}
                        <div className="col-lg-6">
                          <div className="table-responsive">
                            <table className="table">
                              <tbody>
                                <tr>
                                  <th style={{ width: "50%" }}>Total Amount before Tax:</th>
                                  <td>Rs. {totalSubtotal || 0}</td>
                                </tr>
                                <tr>
                                  <th>Total CGST:</th>
                                  <td>Rs. {tax.cgstTax || 0}</td>
                                </tr>
                                <tr>
                                  <th>Total SGST:</th>
                                  <td>Rs. {tax.sgstTax || 0}</td>
                                </tr>
                                <tr>
                                  <th>Total IGST:</th>
                                  <td>Rs. {tax.igstTax || 0}</td>
                                </tr>
                                <tr>
                                  <th>Total Tax Amount:</th>
                                  <td>Rs. {totalTax || 0}</td>
                                </tr>
                                <tr>
                                  <th>Freight:</th>
                                  <td>
                                    Rs.{" "}
                                    <input
                                      type="number"
                                      step="any"
                                      value={freight}
                                      onChange={handleFreightChange}
                                      style={{
                                        background: "#fff",
                                        border: "1px solid #ced4da",
                                        borderRadius: "6px",
                                        padding: "4px 8px",
                                        width: "100px",
                                      }}
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <th>Insurance:</th>
                                  <td>
                                    Rs.{" "}
                                    <input
                                      type="number"
                                      step="any"
                                      value={insurance}
                                      onChange={handleInsuranceChange}
                                      style={{
                                        background: "#fff",
                                        border: "1px solid #ced4da",
                                        borderRadius: "6px",
                                        padding: "4px 8px",
                                        width: "100px",
                                      }}
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <th>Packing and Forwarding Charges:</th>
                                  <td>
                                    Rs.{" "}
                                    <input
                                      type="number"
                                      step="any"
                                      value={packingCharges}
                                      onChange={handlePackingChargesChange}
                                      style={{
                                        background: "#fff",
                                        border: "1px solid #ced4da",
                                        borderRadius: "6px",
                                        padding: "4px 8px",
                                        width: "100px",
                                      }}
                                    />
                                  </td>
                                </tr>
                                <tr
                                  style={{
                                    fontSize: "1.4rem",
                                    fontWeight: "bold",
                                    color: "var(--inv-primary)",
                                    backgroundColor: "#f7f5ff",
                                  }}
                                >
                                  <th>Grand Total:</th>
                                  <td>Rs. {totalGrandtotal || 0}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* Footer Actions */}
                      <div className="row no-print mt-4">
                        <div className="col-12 d-flex justify-content-between">
                          <button
                            type="button"
                            className="btn btn-default"
                            onClick={() => window.print()}
                            style={{
                              borderRadius: "8px",
                              padding: "9px 18px",
                              fontWeight: "600",
                              border: "1px solid #ced4da",
                            }}
                          >
                            <i className="fas fa-print mr-1" /> Print
                          </button>
                          <div className="d-flex gap-2">
                            <button
                              type="button"
                              className="btn btn-success mr-2"
                              onClick={handleSavePurchaseOrder}
                              disabled={isSaving}
                              style={{
                                borderRadius: "8px",
                                padding: "9px 20px",
                                fontWeight: "600",
                                backgroundColor: "#10b981",
                                borderColor: "#10b981",
                              }}
                            >
                              <i className="fas fa-save mr-1" />{" "}
                              {isSaving ? "Saving..." : "Submit Purchase Order"}
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary mr-2"
                              onClick={() => window.print()}
                              style={{
                                borderRadius: "8px",
                                padding: "9px 20px",
                                fontWeight: "600",
                                backgroundColor: "#3b82f6",
                                borderColor: "#3b82f6",
                              }}
                            >
                              <i className="fas fa-download mr-1" /> Generate PDF
                            </button>
                            <button
                              type="button"
                              className="btn btn-info"
                              onClick={handleESignModal}
                              style={{
                                borderRadius: "8px",
                                padding: "9px 20px",
                                fontWeight: "600",
                                backgroundColor: "#06b6d4",
                                borderColor: "#06b6d4",
                              }}
                            >
                              <i className="fas fa-signature mr-1" /> E-Sign
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div style={{ height: "140px" }} />
          </div>
          <UserFooter />
        </div>
      </div>
      <ESign
        lgShow={lgShow}
        handleCloseModal={handleCloseModal}
        sigCanvasRef={sigCanvasRef}
      />
    </>
  );
};

export default CreatePurchaseOrder;
